import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Plus, X } from "lucide-react";

export const PRAZOS_CONCESSIONARIO = [
  { nome: "Stock nacional", dias: 1 },
  { nome: "Alemanha / estrangeiro", dias: 21 },
];

export const PrazosEditor = ({ prazos, onChange }) => {
  const set = (i, k, v) => onChange(prazos.map((p, idx) => (idx === i ? { ...p, [k]: v } : p)));
  return (
    <div className="col-span-2" data-testid="fornecedor-prazos">
      <Label className="text-xs">Prazos possíveis (escolhidos em cada linha do pedido)</Label>
      <div className="space-y-1.5 mt-1">
        {prazos.map((p, i) => (
          <div key={i} className="flex gap-2 items-center">
            <Input className="h-8 text-xs" placeholder="ex.: Alemanha" value={p.nome} onChange={(e) => set(i, "nome", e.target.value)} data-testid={`prazo-nome-${i}`} />
            <Input className="h-8 w-20 text-xs" type="number" min={1} max={120} value={p.dias} onChange={(e) => set(i, "dias", e.target.value)} data-testid={`prazo-dias-${i}`} />
            <span className="text-[11px] text-slate-400">dias</span>
            <button type="button" className="text-slate-400 hover:text-rose-600" onClick={() => onChange(prazos.filter((_, idx) => idx !== i))} data-testid={`prazo-remover-${i}`}><X size={14} /></button>
          </div>
        ))}
        <Button type="button" size="sm" variant="outline" className="h-7 text-xs gap-1" onClick={() => onChange([...prazos, { nome: "", dias: 1 }])} data-testid="prazo-adicionar"><Plus size={12} /> Prazo</Button>
      </div>
    </div>
  );
};
